import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import {
  AppBar,
  Box,
  Button,
  Menu,
  MenuItem,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { loginRequest } from "../authentication/authConfig";

export const NavigationBar = () => {
  const { instance } = useMsal();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);
  const [navAnchorEl, setNavAnchorEl] = useState(null);

  const handleAccountMenuOpen = (event) => {
    setAccountAnchorEl(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountAnchorEl(null);
  };

  const handleNavMenuOpen = (event) => {
    setNavAnchorEl(event.currentTarget);
  };

  const handleNavMenuClose = () => {
    setNavAnchorEl(null);
  };

  let activeAccount = instance ? instance.getActiveAccount() : null;

  const handleLoginRedirect = () => {
    document.body.style.overflow = "hidden";
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    document.body.style.overflow = "auto";
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
    });
  };

  const accountLabel = activeAccount?.name || "Unknown";

  const renderAccountButton = () => (
    <Box sx={{ minWidth: 0, flexShrink: 0 }}>
      {activeAccount ? (
        <>
          <Button
            variant="contained"
            color="warning"
            onClick={handleAccountMenuOpen}
            sx={{
              maxWidth: { xs: 132, sm: 220, md: 320 },
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {accountLabel}
          </Button>
          <Menu
            anchorEl={accountAnchorEl}
            open={Boolean(accountAnchorEl)}
            onClose={handleAccountMenuClose}
          >
            <MenuItem onClick={handleLogoutRedirect}>Sign out</MenuItem>
          </Menu>
        </>
      ) : (
        <Button variant="contained" color="primary" onClick={handleLoginRedirect}>
          Sign in
        </Button>
      )}
    </Box>
  );

  const renderDesktopLinks = () => (
    <>
      <Button href="/" color="inherit">
        Reports
      </Button>
      <Button href="/schedule" color="inherit">
        Schedule
      </Button>
    </>
  );

  const renderMobileLinks = () => (
    <>
      <Button
        color="inherit"
        startIcon={<MenuIcon />}
        onClick={handleNavMenuOpen}
        sx={{ flexShrink: 0 }}
      >
        Menu
      </Button>
      <Menu
        anchorEl={navAnchorEl}
        open={Boolean(navAnchorEl)}
        onClose={handleNavMenuClose}
      >
        <MenuItem component="a" href="/" onClick={handleNavMenuClose}>
          Reports
        </MenuItem>
        <MenuItem component="a" href="/schedule" onClick={handleNavMenuClose}>
          Schedule
        </MenuItem>
      </Menu>
    </>
  );

  return (
    <AppBar sx={{ background: "#1A1A1A" }}>
      <Toolbar sx={{ gap: 1, minWidth: 0 }}>
        {!isMobile && (
          <Box
            sx={{
              flexGrow: 1,
              minWidth: 0,
              color: "white",
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            Coder Sports Academy
          </Box>
        )}

        {isMobile && <Box sx={{ flexGrow: 1 }} />}
        {activeAccount && (isMobile ? renderMobileLinks() : renderDesktopLinks())}
        {renderAccountButton()}
      </Toolbar>
    </AppBar>
  );
};
